import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 初始化用户认证状态并创建Vue实例
async function initializeApp() {
  // 先初始化认证状态
  await store.dispatch("user/initializeAuth");
  
  // 创建Vue实例
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

// 启动应用
initializeApp();
